<template lang='pug'>
  .country-details
    a.country-link.nav-link( href='#country-select-modal' data-toggle='modal')
      .svg-icon.sephora-country-flag(:class='country')
      div.abbration
        span.selected-country(v-text='countryCode')
        span |
        span(v-text='defaultLanguage.key')
</template>

<script>
import { languagesByCountry } from '@/modules/config/locale.js'
export default {
  computed: {
    country: () => vueSupport.currentlySelectedCountry.name.split(' ').join('-').toLowerCase(),
    countryCode: () => vueSupport.currentlySelectedCountry.iso_alpha2_code,
    defaultLanguage: () => languagesByCountry[I18n.siteCountryLs].languagesName.find(lang => lang.value === I18n.language)
  }
}
</script>

<style scoped lang='scss'>
  .sephora-country-flag{
    height: 16px;
    width: 24px;
  }

  .country-link{
    height: 16px;
    width: 100px;
    display: flex;
    align-items: center;
    margin-right: 15px;
  }

  .abbration {
    height: 10px;
    width: 44px;
    color: $white;
    font-family: "Sephora Sans";
    font-size: 10px;
    font-weight: 500;
    letter-spacing: 0.11px;
    line-height: 12px;
    text-align: center;
    padding: 0 5px;

    :lang(vi) {
      font-family: Helvetica, CenturyGothic, Arial;
    }
  }

  .abbration span{
    padding: 0 2px;
  }

  @media screen and (max-width: 767px){
    .country-link{
      width: 170px;
    }
    .abbration {
      height: 14px;
      width: 115px;
      color: $black;
      font-size: 14px;
      letter-spacing: 0.15px;
      line-height: 17px;
      font-weight: bold;
    }
  }
</style>
